import React, { SyntheticEvent, useState } from 'react';
import { Button, Checkbox, FormField, Header, Icon, Message, Modal, ModalActions, ModalContent, Popup } from 'semantic-ui-react';
import CustomMap from '../../../components/CustomMap';
import { ProspectAppointmentType } from '../../../types/entities/ProspectAppointment';

interface ProspectVisitedModalProps {
    prospectAppointmentId: string;
    prospectAppointmentType: ProspectAppointmentType;
    disabled?: boolean;
    onSubmit: (event: SyntheticEvent, prospectId: string | undefined, latitude: number | undefined, longitude: number | undefined) => void;
    defaultLatitude?: number | null;
    defaultLongitude?: number | null;
}

const ProspectVisitedModal = ({
    prospectAppointmentId,
    prospectAppointmentType,
    disabled,
    onSubmit,
    defaultLatitude,
    defaultLongitude
}: ProspectVisitedModalProps) => {

    const [openModal, setOpenModal] = useState(false);
    const [prospectVisited, setProspectVisited] = useState(false);
    const [latitude, setLatitude] = useState<number | undefined>(defaultLatitude ?? undefined);
    const [longitude, setLongitude] = useState<number | undefined>(defaultLongitude ?? undefined);

    const isLocationSaved = defaultLatitude != null && defaultLongitude != null;

    const handleOpen = (event: SyntheticEvent) => {
        event.preventDefault();
        setLatitude(defaultLatitude ?? undefined);
        setLongitude(defaultLongitude ?? undefined);
        setProspectVisited(false);
        setOpenModal(true);
    };

    const handleCancel = (event: SyntheticEvent) => {
        event.preventDefault();
        setOpenModal(false);
    };

    return (
        <Modal
            closeOnDimmerClick
            closeIcon={true}
            size="small"
            onClose={(event) => handleCancel(event)}
            open={openModal}
            trigger={
                <Popup
                    trigger={
                        <Button color="green" icon size="mini" onClick={(event) => handleOpen(event)} disabled={disabled}>
                            <Icon name="home" />
                        </Button>
                    }
                    content='Marcar prospecto visitado'
                    position='top center'
                    size='small'
                    inverted
                />
            } >
            <Header icon="home" content="Prospecto visitado" />
            <ModalContent>

                {prospectAppointmentType === "PROSPECT_HOME" && (
                    <>
                        {isLocationSaved ? (
                            <Message
                                info
                                icon="map marker alternate"
                                header="Ubicación ya registrada"
                                content="Este es un domicilio existente y la ubicación ya fue guardada anteriormente, por lo que no es necesario actualizarla."
                            />
                        ) : (
                            <Message
                                warning
                                icon="info circle"
                                header="Confirmar Ubicación"
                                content="Asegúrate de que la visita se realizará en la ubicación correcta antes de marcar la ubicación en el mapa."
                            />
                        )}
                        <CustomMap
                            height="400px"
                            width="100%"
                            enableCurrentLocation={!isLocationSaved}
                            initialLatitude={defaultLatitude}
                            initialLongitude={defaultLongitude}
                            draggable={!isLocationSaved}
                            onLocationChange={(latitude, longitude) => {
                                if (!isLocationSaved) {
                                    setLatitude(latitude);
                                    setLongitude(longitude);
                                }
                            }}
                        />
                    </>
                )}

                {prospectAppointmentType === "SHOWROOM" && (
                    <Message
                        warning
                        icon="home"
                        content="El prospecto visito nuestras instalaciones en el showroom. Confirma que la visita se completo adecuadamente."
                    />
                )}

                <div className="ui form">
                    <FormField>
                        <Checkbox
                            label="Confirmo que la visita concluyo exitosamente."
                            checked={prospectVisited}
                            onChange={(event, data) => setProspectVisited(prospectVisited ? false : true)}
                        />
                    </FormField>
                </div>
            </ModalContent>
            <ModalActions>
                <Button onClick={(event) => handleCancel(event)}>
                    <Icon name="cancel" /> Cancelar
                </Button>
                <Button color="green" onClick={(event) => onSubmit(event, prospectAppointmentId, latitude, longitude)} disabled={!prospectVisited}>
                    <Icon name="checkmark" /> Aceptar
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default ProspectVisitedModal;
